import styled from '@emotion/styled'

export const Wrapper = styled.div`
  position: relative;
  cursor: pointer;
  z-index: 50;
`
